// extracted by mini-css-extract-plugin
export default {"icon":"fileDrop_icon__Vl+fQ","style":"fileDrop_style__tQgAQ","subtext":"fileDrop_subtext__zfw9x"};